import { CrossSellingPointer } from "../../others/crossSellingPointer.js";
import { RPM } from "../names.js";
/**
 * Upload file in grid view and "Add new" page.
 */ const crossRpmUpload = ()=>CrossSellingPointer.waitForVisibleElement("body.wp-admin.upload-php #wpbody-content .upload-ui .button-hero:visible, body.wp-admin.media-new-php #media-items .media-item:first:visible", RPM, "upload");
export { crossRpmUpload };
